import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Post, Tag } from '../interfaces/post.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PostService {
  private blogApiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.blogApiUrl = environment.blogApiUrl;
  }

  public getLatestPosts(numberOfPosts: number): Observable<Post[]> {
    return forkJoin(
      this.httpClient.get<Tag[]>(`${ this.blogApiUrl }/tags`),
      this.httpClient.get<Post[]>(`${ this.blogApiUrl }/posts?per_page=${ numberOfPosts }`)
    ).pipe(
      map((tagsAndPosts: [Tag[], Post[]]) => {
        const tags: Tag[] = tagsAndPosts[0].map(({ id, name, link }) => ({ id, name, link }));
        const posts: Post[] = tagsAndPosts[1].map(({ id, date, link, title, excerpt, tags }) => ({ id, date, link, title, excerpt, tags }));

        posts.forEach((post: Post) => {
          for (let i = 0; i < post.tags.length; i++) {
            tags.forEach((tag: Tag) => {
              if (post.tags[i] === tag.id) {
                post.tags[i] = tag;
              }
            });
          }
        });

        return posts;
      })
    );
  }
}
